import React from 'react';
import AboutOlxGroup from '../Components/InfoPages/AboutOlxGroup';

function AboutPage() {
  return <AboutOlxGroup />;
}

export default AboutPage;
